<template>
  <div class="mypage-button_block">
    <div class="left">
      <button @click="onClickClientButton()">
        <img class='base_image' src='@/assets/image/pages/mypage/top/button_client.png'/>
      </button>
      <router-link :to="{ name: 'UserDetail'}">
        <img class='base_image' src='@/assets/image/pages/mypage/top/button_toroku.png'>
      </router-link>
    </div>
    <div class="right">
      <button @click="onClickOperatorButton()">
        <img class='base_image' src='@/assets/image/pages/mypage/top/button_operator.png'/>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import collection from '@/assets/js/functions/firebase/firestore/collection';
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "ButtonBlock",

    mixins: [collection],

    data() {
      return {
        newOperator: {
          freeMoment: null,
          status: 'waiting',
          startAt: null,
          skills: null,
          softwares: null,
          office: null,
          scores: {
            total: 3,
            perfection: 3,
            speed: 3,
            numberOfScores: 10,
          }
        },

        newClient: {
          scores: {
            total: 3,
            accuracy: 3,
            cost: 3,
            numberOfScores: 10,
          }
        },
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid', customClaim: 'auth/customClaim'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    methods: {
      async onClickClientButton() {
        if (!this.customClaim.isClient) {
          await this.createDoc(
            COLLECTION_NAMES.CLIENTS,
            this.uid,
            this.newClient
          ).then(async () => {
            window.location.href = '/mypage/client/';
          }).catch(() => {
            // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
          });
        } else {
          this.$router.push({name: 'ClientTop'})
        }
      },

      async onClickOperatorButton() {
        if (!this.customClaim.isOperator) {
          await this.createDoc(
            COLLECTION_NAMES.OPERATORS,
            this.uid,
            this.newOperator
          ).then(async () => {
            window.location.href = '/mypage/operator/';
          }).catch(() => {
            // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
          });
        } else {
          this.$router.push({name: 'OperatorTop'})
        }
      },
    }
  }
</script>


<style lang="scss" scoped>
  .mypage-button_block {
    @include double_columns($left: 45%, $right: 45%);

    .base_image {
      margin-top: 4rem;
    }
  }
</style>
